import React from 'react';
import { withRouter } from 'react-router-dom';
import { Button, Toast } from 'antd-mobile';
import PropTypes from 'prop-types';
import tools from '../../utils/tools';
import styles from './order.module.less';
import { getOrderDetailsByH5 } from '../../service/chat-service';

// 图片资源
import myBackGround from '../../public/images/rwx_user_img_mybackground.png';
import unpaid from '../../public/images/rwx_order_img_unpaid.png';
import paid from '../../public/images/rwx_order_img_paid.png';
import enterprise from '../../public/images/rwx_buy_icon-enterprise.png';

const propTypes = {
  history: PropTypes.arrayOf(PropTypes.string),
};
const defaultProps = {
  history: [],
};

class OrderDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    document.title = '订单详情';
    const orderId = tools.getQueryString('orderId');
    getOrderDetailsByH5(`?orderId=${orderId}`).then((res) => {
      if (res.code === 10000) {
        this.setState({
          ...res.data.orderVo,
        });
      } else {
        Toast.fail(res.message, 1);
      }
    });
  }

  againPay = () => {
    // 再次支付
    const { history } = this.props;
    const { id, price } = this.state;
    history.push(`/pay?orderId=${id}&price=${price}`);
  }

  render() {
    const {
      id,
      status,
      payTime,
      createTime,
      orderAmount,
      companyName,
      productImg,
      productName,
      price,
      num,
      accountMobile,
      buyerRemark,
    } = this.state;
    let htmlHeader = null;
    let actualPaymentHtml = null;
    let htmlFooter = null;
    if (status === '2') {
      htmlHeader = <span className={styles.header_success}>订单已完成</span>;
      htmlFooter = (
        <p>
          <span>支付时间</span>
          <span>{tools.formatUnixtimestamp(payTime)}</span>
        </p>
      );
    } else {
      const endTime = createTime + 24 * 60 * 60 * 1000;
      const startTime = new Date().getTime();
      const { hour = 0, min = 0 } = tools.getTimeDifference(endTime, startTime);
      htmlHeader = (
        <div className={styles.header_fail}>
          <p>等待支付费用</p>
          <span>
            剩
            {hour}
            小时
            {min}
            分自动关闭
          </span>
        </div>
      );
      actualPaymentHtml = (
        <div className={styles.actual_payment}>
          实付：
          <span>
            <span>￥</span>
            {(orderAmount / 100).toFixed(2)}
          </span>
        </div>
      );
      htmlFooter = (
        <div className={styles.no_pay}>
          {/* <Button className={`${styles.first_btn} ${styles.btns}`}>取消订单</Button> */}
          <Button
            onClick={this.againPay.bind(this)}
            className={`${styles.second_btn} ${styles.btns}`}
            role="button"
            tabIndex={0}
          >
            付款
          </Button>
        </div>
      );
    }
    return (
      <div className={styles.order_detail}>
        <header style={{ background: `url(${myBackGround})` }} className={styles.header}>
          <p className={styles.header_title}>订单详情</p>
          <div className={styles.header_bottom}>
            {htmlHeader}
            {/* 根据转态，记得改对应图片显示 */}
            <img src={status === '2' ? paid : unpaid} alt="" />
          </div>
        </header>
        <main>
          <div className={styles.product_info}>
            <p className={styles.product_info_title}>
              <img src={enterprise} alt="" />
              <span>{companyName}</span>
            </p>
            <div className={styles.product_bottom_main}>
              <div className={styles.left}>
                <img src={productImg} alt="" />
              </div>
              <div className={styles.right}>
                <p className={styles.product_info_title}>
                  {productName}
                </p>
                <p>
                  <span>
                    ￥
                    {(price / 100).toFixed(2)}
                  </span>
                  <span>
                    数量：x
                    {num}
                    {' '}
                  </span>
                </p>
              </div>
            </div>
          </div>
          <div className={styles.buy_count}>
            <span>购买数量</span>
            <span>{num}</span>
          </div>
          <div className={styles.buy_info}>
            <p className={styles.phone}>
              手机号码
              <span>{accountMobile}</span>
            </p>
            <div className={styles.message}>
              <span className={styles.message_left}>买家留言</span>
              <p>{buyerRemark || '暂无'}</p>
            </div>
            <div className={styles.money}>
              <span>
                共
                {num}
                件商品
              </span>
              <span>
                小计： ￥
                {(orderAmount / 100).toFixed(2)}
              </span>
            </div>
            {actualPaymentHtml}
          </div>
        </main>
        <footer>
          <p className={styles.order_no}>
            <span>订单编号</span>
            <span>{id}</span>
          </p>
          <p className={styles.create_time}>
            <span>创建时间</span>
            <span>{tools.formatUnixtimestamp(createTime)}</span>
          </p>
          {htmlFooter}
        </footer>
      </div>
    );
  }
}

OrderDetail.propTypes = propTypes;
OrderDetail.defaultProps = defaultProps;

export default withRouter(OrderDetail);
